export default __webpack_public_path__ + "static/media/character-exit.aa20f1d7.svg";